import { render } from "./CustomerOrderModal.vue?vue&type=template&id=d4b583cc"
import script from "./CustomerOrderModal.vue?vue&type=script&lang=js"
export * from "./CustomerOrderModal.vue?vue&type=script&lang=js"

import "./CustomerOrderModal.vue?vue&type=style&index=0&id=d4b583cc&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__